import { errorHandler } from "./error.service";
import { http, URL } from "./http.service";

export const addExpenseData = async (bussinessUuid, data) => {
  try {
    let resp = await http.post(`${URL}/expense/${bussinessUuid}/add`, data);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const getExpenses = async (bussinessUuid, params = {}) => {
  try {
    const queryString = new URLSearchParams(params).toString();
    let resp = await http.get(`${URL}/expense/${bussinessUuid}/get-expenses?${queryString}`);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};
export const addSalaryExpenses = async (bussinessUuid) => {
  try {
    let resp = await http.post(`${URL}/expense/${bussinessUuid}/add-salary`);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const updateExpenses = async (bussinessUuid, expenseID, data) => {
  try {
    let resp = await http.put(
      `${URL}/expense/${bussinessUuid}/${expenseID}`,
      data
    );
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const deleteExpenses = async (bussinessUuid, expenseID) => {
  try {
    let resp = await http.delete(
      `${URL}/expense/${bussinessUuid}/${expenseID}`
    );
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const getDocumentDownloadUrl = async (bussinessUuid, expenseID) => {
  try {
    let resp = await http.get(
      `${URL}/expense/${bussinessUuid}/${expenseID}/download-document`
    );
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};
